import constants from '@legacy/helpers/constants/index';

export default constants;